{
  "info": "Информация",
  "negative": "Ошибка",
  "positive": "Успешно"
}
